import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import RelatedGifts from '../../RelatedGifts';
import { useSelector } from 'react-redux';
import { SiteSettingsContext } from '../../../utils/context';
import { getRelatedProductsForGift } from '../../../utils/Gifts/transforms.gifts.data';

import styles from './index.module.scss';

const BBRelatedProducts = ({ items, productId }) => {
  const products = useSelector((state) => state.productsStorage.gifts);
  const settings = useContext(SiteSettingsContext);
  const relatedGifts = getRelatedProductsForGift(products[productId], products, items);

  if (!relatedGifts.length) {
    return null;
  }

  return (
    <div className={`bb ${styles['bb-related-products']}`}>
      <div className={'container'}>
        <RelatedGifts
          title={settings.giftDetailPage.relatedGiftsTitle || 'You might also like'}
          productIds={relatedGifts}
        />
      </div>
    </div>
  );
};

BBRelatedProducts.propTypes = {
  items: PropTypes.array.isRequired,
  productId: PropTypes.number.isRequired,
};

export default BBRelatedProducts;
